module.exports = __webpack_public_path__ + "img/bind.b70f7466.png";